import { render, staticRenderFns } from "./CapSubjectList.vue?vue&type=template&id=9fbb4d70&scoped=true&lang=pug&"
import script from "./CapSubjectList.vue?vue&type=script&lang=js&"
export * from "./CapSubjectList.vue?vue&type=script&lang=js&"
import style0 from "./CapSubjectList.vue?vue&type=style&index=0&id=9fbb4d70&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fbb4d70",
  null
  
)

export default component.exports